import { Button } from '@blueprintjs/core'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React from 'react'
import LoadableVisibility from 'react-loadable-visibility/react-loadable'
import LoadingCover from '../commonInterface/loadingCover'
import MobileMain from '../mobile/mobileMain'

const LoadingForWindow = ({ pastDelay, error, timedOut }) => {
  if (error) {
    return <div>error</div>
  } else if (timedOut) {
    return <div>timeOut</div>
    // } else if (pastDelay) {
    //   return <Spinner size={100} intent={'primary'} css={css`margin-top: 40vh;`} />
  } else {
    return <LoadingCover showSpinner spinnerSize={100}
      text={'Loading'} action={
        <Button minimal intent={'warning'} text={'Reload'} onClick={() => {
          location.reload()
        }} />} />
  }
}

const lodableConfigObject = {
  loading: LoadingForWindow
}

const SharingPage = LoadableVisibility({
  loader: () => import('./sharingPage'),
  ...lodableConfigObject
})

const uAgent = window.navigator.userAgent.toLowerCase()
const mobilePhones = /iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i
const isMobile = mobilePhones.test(uAgent)

function SharingPageWindow (props) {
  return isMobile ? (<MobileMain {...props} />) : <SharingPage {...props} />
}

export default SharingPageWindow
